module.exports = __webpack_public_path__ + "static/Google-device-94208a2f51f6f37b14dddc462d53e9da.png";